import { createSelector } from '@reduxjs/toolkit'

import { selectMarketYoyGrowthExpectationState } from './selectMarketYoyGrowthExpectationState'

export const selectIsMarketYoyGrowthExpectationsFetching = createSelector(
  [selectMarketYoyGrowthExpectationState],
  (state) => state.isLoading
)
